'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var titan = require('@narvar/titan-client');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var titan__default = /*#__PURE__*/_interopDefaultLegacy(titan);

function createAssistTitanClient(_ref) {
  let {
    titanConfig,
    portalType,
    orderNumber,
    claimType,
    source,
    locale,
    cartId,
    extra_properties
  } = _ref;
  const client = titan__default["default"]({
    sourceWriteKey: titanConfig.sourceWriteKey,
    url: titanConfig.url
  });
  return {
    track: payload => {
      const sentAt = new Date().toISOString();
      return client.track(createTrackPayload({
        assistTrackPayload: payload,
        orderNumber,
        claimType,
        sentAt,
        locale,
        source,
        portalType,
        cartId,
        extra_properties
      }));
    },
    page: payload => {
      const sentAt = new Date().toISOString();
      return client.page(createPagePayload({
        assistPagePayload: payload,
        sentAt,
        source,
        locale,
        portalType,
        extra_properties
      }));
    },
    batch: payload => {
      const sentAt = new Date().toISOString();
      const batchPayload = {
        batch: payload.batch.map(assistEventPayload => {
          if (assistEventPayload.type === 'page') {
            return createPagePayload({
              assistPagePayload: assistEventPayload,
              sentAt,
              source,
              locale,
              portalType,
              extra_properties
            });
          } else {
            return createTrackPayload({
              assistTrackPayload: assistEventPayload,
              orderNumber,
              claimType,
              sentAt,
              locale,
              source,
              portalType,
              cartId,
              extra_properties
            });
          }
        })
      };
      return client.batch(batchPayload);
    }
  };
}
function getContext(_ref2) {
  let {
    locale
  } = _ref2;
  return {
    locale,
    userAgent: window.navigator.userAgent,
    screen: {
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
      width: window.screen.availWidth,
      height: window.screen.availHeight,
      // Some devices have a devicePixelRatio that is not an integer.
      // Sending this value as density is not supported by titan right now.
      // So commenting this value out for now since this is breaking titan
      // calls when the value is not an integer.
      // density: window.devicePixelRatio,
      density: 0
    }
  };
}
function createTrackPayload(_ref3) {
  var _assistTrackPayload$p;
  let {
    assistTrackPayload,
    sentAt,
    source,
    claimType,
    orderNumber,
    locale,
    portalType,
    cartId,
    extra_properties
  } = _ref3;
  return {
    type: 'track',
    channel: 'web',
    context: getContext({
      locale
    }),
    sentAt,
    ...assistTrackPayload,
    properties: {
      narvar_product_context: 'assist',
      order_id: orderNumber,
      cart_id: cartId,
      filters: [...(claimType ? [{
        type: 'reason',
        value: claimType
      }] : [])],
      ...assistTrackPayload.properties,
      extra_properties: [...((assistTrackPayload === null || assistTrackPayload === void 0 ? void 0 : (_assistTrackPayload$p = assistTrackPayload.properties) === null || _assistTrackPayload$p === void 0 ? void 0 : _assistTrackPayload$p.extra_properties) ?? []), {
        key: 'source',
        value: source
      }, {
        key: 'portal_type',
        value: portalType
      }, ...(extra_properties ?? [])]
    }
  };
}
function createPagePayload(_ref4) {
  let {
    assistPagePayload,
    sentAt,
    source,
    locale,
    portalType,
    extra_properties
  } = _ref4;
  return {
    type: 'page',
    channel: 'web',
    context: getContext({
      locale
    }),
    sentAt,
    ...assistPagePayload,
    properties: {
      narvar_product_context: 'assist',
      referrer: document.referrer,
      url: window.location.href,
      title: document.title,
      extra_properties: [{
        key: 'source',
        value: source
      }, {
        key: 'portal_type',
        value: portalType
      }, ...(extra_properties ?? [])]
    }
  };
}

exports["default"] = createAssistTitanClient;
